var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4442 14.0052C10.3236 14.0052 10.2098 13.9818 10.1026 13.9349C9.9955 13.888 9.90845 13.8244 9.84148 13.744L4.69866 8.60121C4.6183 8.52085 4.55469 8.43045 4.50781 8.33C4.46094 8.22956 4.4375 8.11907 4.4375 7.99853C4.4375 7.75746 4.5212 7.55322 4.68861 7.38581C4.85602 7.2184 5.06026 7.1347 5.30133 7.1347C5.42187 7.1347 5.53236 7.15814 5.6328 7.20501C5.73325 7.25188 5.82365 7.3155 5.90401 7.39586L10.4442 11.936L14.9843 7.39586C15.0647 7.3155 15.1551 7.25188 15.2555 7.20501C15.356 7.15814 15.4664 7.1347 15.587 7.1347C15.828 7.1347 16.0323 7.2184 16.1997 7.38581C16.3671 7.55322 16.4508 7.75746 16.4508 7.99853C16.4508 8.11907 16.4274 8.22956 16.3805 8.33C16.3336 8.43045 16.27 8.52085 16.1897 8.60121L11.0468 13.744C10.9799 13.8244 10.8928 13.888 10.7857 13.9349C10.6785 13.9818 10.5647 14.0052 10.4442 14.0052Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowBlack);
export default __webpack_public_path__ + "static/media/downArrowBlack.e085efde88da1324ef243410304fe2e5.svg";
export { ForwardRef as ReactComponent };